import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DoesUserExistQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type DoesUserExistQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', email: string }> };


export const DoesUserExistDocument = gql`
    query doesUserExist($email: String!) {
  users(where: {email: {_eq: $email}}) {
    email
  }
}
    `;

/**
 * __useDoesUserExistQuery__
 *
 * To run a query within a React component, call `useDoesUserExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoesUserExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoesUserExistQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDoesUserExistQuery(baseOptions: Apollo.QueryHookOptions<DoesUserExistQuery, DoesUserExistQueryVariables> & ({ variables: DoesUserExistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoesUserExistQuery, DoesUserExistQueryVariables>(DoesUserExistDocument, options);
      }
export function useDoesUserExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoesUserExistQuery, DoesUserExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoesUserExistQuery, DoesUserExistQueryVariables>(DoesUserExistDocument, options);
        }
export function useDoesUserExistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoesUserExistQuery, DoesUserExistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoesUserExistQuery, DoesUserExistQueryVariables>(DoesUserExistDocument, options);
        }
export type DoesUserExistQueryHookResult = ReturnType<typeof useDoesUserExistQuery>;
export type DoesUserExistLazyQueryHookResult = ReturnType<typeof useDoesUserExistLazyQuery>;
export type DoesUserExistSuspenseQueryHookResult = ReturnType<typeof useDoesUserExistSuspenseQuery>;
export type DoesUserExistQueryResult = Apollo.QueryResult<DoesUserExistQuery, DoesUserExistQueryVariables>;